import { useEffect, useState } from "react";

export default function ProductList() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/api/products/all")
      .then((res) => res.json())
      .then((data) => {
        setProducts(data.products || []);
        setLoading(false);
      });
  }, []);

  if (loading) return <p className="text-center">Loading products...</p>;

  if (products.length === 0) {
    return <p className="text-center text-gray-500">No products found.</p>;
  }

  return (
    <div className="max-w-5xl mx-auto mt-10 bg-white rounded-xl shadow p-6">
      <h2 className="text-xl font-bold mb-4 text-[#785f14]">Product List</h2>
      <table className="w-full table-auto border-collapse text-sm sm:text-base">
        <thead>
          <tr className="bg-gray-100">
            <th className="border px-4 py-2 text-left">Website</th>
            <th className="border px-4 py-2 text-left">Description</th>
            <th className="border px-4 py-2 text-left">Client</th>
          </tr>
        </thead>
        <tbody>
          {products.map((p) => (
            <tr key={p.product_id}>
              <td className="border px-4 py-2">{p.website}</td>
              <td className="border px-4 py-2">{p.description}</td>
              <td className="border px-4 py-2">
                {p.firstname} {p.lastname} <br />
                <span className="text-xs text-gray-500">{p.email}</span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
